import {EditBaseCtrl} from "./EditBaseCtrl";
import {Template} from "../../entities/Template";
import {NotificationService} from "../../services/NotificationService";
import {EditTemplateModel} from "../../models/edit/EditTemplateModel";
import { StateService, StateParams } from "@uirouter/angularjs";

export class EditTemplateCtrl extends EditBaseCtrl<Template> {
    public static $inject = ['$scope','$state','$stateParams','NotificationService','EditTemplateModel'];
    constructor($scope:any,
                stateService:StateService,
                stateParamsService:StateParams,
                public notifyService:NotificationService,
                public model:EditTemplateModel) {
        super($scope,stateService,stateParamsService,notifyService,model);
        $scope.vm = this;
        this.loadData().then((ok:boolean)=>{
        });
    }
    pagingRoute(): string {
        return "admin.templates";
    }
}
